import "../../../styles/Home.css";
const Home = () => {
  return (
    <div>
      <div className="home">
        <div className="welcome">
        </div>
      </div>
    </div>
  );
};
export default Home;
